import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const WinnersPage = () => {

useEffect(() => {

    const nameMap = {
      'Айк Партизпанян': 'Hayk Partizpanyan',
      'Юлия Байбабина': 'Yuliya Baibabina',
      'Баибабина Юлия': 'Yuliya Baibabina',
      'Партизпанян Айк': 'Hayk Partizpanyan',

      'Вадим Пренко': 'Vadym Prenko',
      'Пренко Вадим': 'Vadym Prenko'
    };

    const replaceName = () => {
      const currentLang = document.documentElement.lang || '';
      const isRu = currentLang.startsWith('ru');

      document
        .querySelectorAll('[data-translate-custom="true"]')
        .forEach((el) => {
          const original = (el.getAttribute('data-original-name') || '').trim();
          if (!original) return;

          if (!isRu && nameMap[original]) {

            if (el.textContent !== nameMap[original]) {
              el.textContent = nameMap[original];
            }
          } else {

            if (el.textContent !== original) {
              el.textContent = original;
            }
          }
        });
    };

    const bodyObserver = new MutationObserver(replaceName);
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    const htmlObserver = new MutationObserver(replaceName);
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
    });

    replaceName();

    return () => {
      bodyObserver.disconnect();
      htmlObserver.disconnect();
    };
  }, []);




  return (
    <>
        <Helmet>
      <html lang="ru" />
      <title>
        Победители Международной премии Лидеров бизнеса — Hayk Partizpanyan
      </title>
      <meta
        name="description"
        content="Победители Международной премии Лидеров бизнеса с 2019 по 2025 год. В числе лауреатов: Hayk Partizpanyan (Айк Партизпанян, Armenia) и другие."
      />
      <link rel="canonical" href="https://businessleadershipaward.com/winners" />
      <meta name="robots" content="index,follow,max-image-preview:large" />

      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Победители Международной премии Лидеров бизнеса"
      />
      <meta
        property="og:description"
        content="Список победителей премии. В числе лауреатов: Hayk Partizpanyan (Айк Партизпанян, Armenia)."
      />
      <meta property="og:url" content="https://businessleadershipaward.com/winners" />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Победители Международной премии Лидеров бизнеса",
          url: "https://businessleadershipaward.com/winners",
          inLanguage: "ru",
          mainEntity: {
            "@type": "Person",
            name: "Айк Партизпанян",
            alternateName: "Hayk Partizpanyan",
            nationality: "Armenia",
            award: "International Business Leadership Award 2022"
          }
        })}
      </script>
    </Helmet>
            <div className="winners-container">
      <div className="overlay">
        <div className="text-content">
          <h3>Победители</h3>
          <h1>Международной премии Лидеров бизнеса с 2019 по 2025 год</h1>
        </div>
      </div>
    </div>

    <div className="winners-section">
      <div className="winners-wrapper">

        <div className="winners-year">
          <h2>2019:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> Олег Иванов (Россия) – <br /> За успешное создание сети магазинов здорового питания, которая за короткий срок охватила все крупные города России, обеспечив значительный рост доходов и клиентской базы.</li>
            <li><strong>Инновационный лидер:</strong> Степан Поляков (Украина) – За разработку уникальной технологии интеллектуальных складов, которая трансформировала логистическую отрасль, снизив издержки на хранение и транспортировку товаров на 25%.</li>
            <li><strong>Лидер устойчивого развития:</strong> Анна Ковальская (Россия) – За внедрение экологически чистых производственных процессов на текстильной фабрике, что позволило сократить выбросы углерода на 30% и уменьшить использование воды в производстве.</li>
            <li><strong>Лидер международного бизнеса:</strong> Ляйсан Утяшева (Казахстан) – За успешное расширение сети ресторанов в странах СНГ, обеспечив рост выручки на 40% и создание новых рабочих мест.</li>
            <li><strong>Прорыв года:</strong> Мария Ручная (Украина) – За запуск мобильного приложения для обучения языкам, которое за первый год собрало более 10 миллионов пользователей по всему миру.</li>
          </ul>
        </div>

        <div className="winners-year">
          <h2>2020:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> Дмитрий Соколов (Россия) – За создание крупнейшей сети частных клиник в России и странах СНГ, обеспечив рост доходов и доступ к высококачественным медицинским услугам для миллионов людей.</li>
            <li><strong>Инновационный лидер:</strong> Максим Осипенко (Украина) – За разработку искусственного интеллекта для диагностики заболеваний на ранних стадиях, который улучшил точность диагностики на 20% и сократил время ожидания результатов.</li>
            <li><strong>Лидер устойчивого развития:</strong> Антон Шевченко (Россия) – За внедрение инновационных методов переработки пластиковых отходов в строительные материалы, которые сократили объемы свалок в стране на 15%.</li>
            <li><strong>Лидер международного бизнеса:</strong> Михаил Степанов (Казахстан) – За успешное расширение бизнеса по производству сельскохозяйственного оборудования в страны Восточной Европы и Азии.</li>
            <li><strong>Прорыв года:</strong> Алена Степанова (Украина) – За создание стартапа в сфере e-commerce, который за первый год увеличил свою оценку до 50 миллионов гривен и завоевал значительную долю рынка.</li>
          </ul>
        </div>

        <div className="winners-year">
          <h2>2021:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> <span   data-translate-custom="true"
  data-original-name="Вадим Пренко">Вадим Пренко</span> (Украина) – За создание и успешную глобальную коммерциализацию инновационной платформы по борьбе с цифровым мошенничеством, которая получила международное признание, как новый стандарт безопасности, обеспечивая защиту финансовых операций для компаний по всему миру.</li>
            <li><strong>Инновационный лидер:</strong> Султан Ахматов (Казахстан) – За создание автономной системы управления для электромобилей, которая снизила потребление энергии на 15%.</li>
            <li><strong>Лидер устойчивого развития:</strong> Иван Соколов (Россия) – За внедрение солнечных панелей на всех производственных площадках компании, что позволило сократить использование ископаемого топлива на 70%.</li>
            <li><strong>Лидер международного бизнеса:</strong> Влад Белоусов (Беларусь) – За успешный вывод бренда модной одежды на рынки Азии и Европы, увеличив международные продажи в два раза.</li>
            <li><strong>Прорыв года:</strong> Мария Наки (Молдова) – За создание стартапа в области виртуальной реальности, который привлек инвестиции в размере $100 миллионов в течение первого года существования.</li>
          </ul>
        </div>

        <div className="winners-year">
          <h2>2022:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> <span data-translate-custom="true"
  data-original-name="Юлия Байбабина">Юлия Байбабина</span>  (Казахстан) – За успешное развитие сети салонов постельного белья, став лидером на рынке Казахстана и за его пределами.</li>
<li>
<strong>Инновационный лидер:</strong>{' '}
<span
id="hayk-partizpanyan"
data-translate-custom="true"
data-original-name="Айк Партизпанян"
>
Айк Партизпанян
</span>{' '}
(Армения) 



 – За внедрение технологии отслеживания примерок в режиме реального времени на основе патента «Умная вешалка», что изменило подход к клиентскому сервису и мерчандайзингу в fashion-ритейле.
 <span className="winner-name-en">
Hayk Partizpanyan (Armenia)
</span>
</li>
            <li><strong>Лидер устойчивого развития:</strong> Султан Керимов (Казахстан) – За создание программы по восстановлению лесов и снижение уровня выбросов углерода через участие крупных корпораций.</li>
            <li><strong>Лидер международного бизнеса:</strong> Андрей Незлобный (Россия) – За успешное расширение бизнеса по производству модной обуви на рынок СНГ.</li>
            <li><strong>Прорыв года:</strong> Иван Попов (Россия) – За запуск высокотехнологичной платформы для онлайн-торговли, которая достигла оборота в 500 миллионов рублей за первый год.</li>
          </ul>
        </div>

        <div className="winners-year">
          <h2>2023:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> Юлия Петрова (Россия) – За развитие сети ресторанов с уникальной концепцией здорового питания, которая быстро завоевала популярность и вышла на международные рынки.</li>
            <li><strong>Инновационный лидер:</strong> Айсан Каримова (Казахстан) – За внедрение технологии переработки морских отходов в материалы для строительства, что изменило подход к управлению отходами в прибрежных городах.</li>
            <li><strong>Лидер устойчивого развития:</strong> Наталья Серебрякова (Россия) – За внедрение программы по минимизации отходов и использование возобновляемых источников энергии на всех предприятиях сети продуктовых магазинов.</li>
            <li><strong>Лидер международного бизнеса:</strong> Геннадий Пономаренко (Беларусь) – За успешное расширение сети технологических центров в Европе и Америке, что увеличило международные доходы компании на 60%.</li>
            <li><strong>Прорыв года:</strong> Мария Потапова (Россия) – За запуск стартапа в сфере агротехнологий, который привлек $20 миллионов инвестиций и стал ведущим игроком на рынке в СНГ.</li>
          </ul>
        </div>

        <div className="winners-year">
          <h2>2024:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> Александр Зубков (Россия) – За создание сети экотуристических баз, которые стали популярны благодаря инновационному подходу к управлению и использованию экологически чистых технологий.</li>
            <li><strong>Инновационный лидер:</strong> Камиля Исмаилова (Азербайджан) – За внедрение новой технологии хранения и транспортировки солнечной энергии, что значительно повысило эффективность использования возобновляемых источников энергии в стране.</li>
            <li><strong>Лидер устойчивого развития:</strong> Ирина Коваленко (Украина) – За разработку и реализацию инициативы по сокращению пластиковых отходов и внедрению экологически чистых упаковочных материалов в крупной сети супермаркетов.</li>
            <li><strong>Лидер международного бизнеса:</strong> Артур Михайлов (Казахстан) – За успешное расширение компании по производству беспилотных летательных аппаратов на рынки Европы и Азии, что привело к значительному увеличению экспортных доходов.</li>
            <li><strong>Прорыв года:</strong> Зарина Рахманова (Узбекистан) – За запуск стартапа в области финтех, который привлек $15 миллионов инвестиций и стал ведущей платформой для цифровых платежей в Центральной Азии.</li>
          </ul>
        </div>

          <div className="winners-year">
          <h2>2025:</h2>
          <ul>
            <li><strong>Предприниматель года:</strong> Даниил Соколов (Россия) – За создание технологичной сети фермерских маркетов с прямыми поставками от производителей. Его бизнес-модель позволила сократить цепочку поставок, повысить качество продуктов и обеспечить доступные цены, став эталоном для современной розничной торговли.</li>
            <li><strong>Инновационный лидер:</strong> Артем Щербицкий (Россия) – За разработку платформы распределенного искусственного интеллекта для промышленности, которая автоматизирует производственные процессы и снижает энергопотребление на 20%, сделав предприятия более эффективными и устойчивыми.</li>
            <li><strong>Лидер устойчивого развития:</strong> Зарина Мусабаева (Казахстан) – За запуск национальной программы “ЭкоГород”, направленной на внедрение зеленых технологий в городскую инфраструктуру, включая переработку отходов, использование солнечной энергии и озеленение общественных пространств.</li>
            <li><strong>Лидер международного бизнеса:</strong> Елена Герасимова (Беларусь) – За успешный вывод косметического бренда на рынки Европы и Ближнего Востока, где бренд занял устойчивые позиции благодаря натуральному составу продукции, адаптированной под региональные особенности и запросы потребителей.</li>
            <li><strong>Прорыв года:</strong> Нуржан Алимхан (Киргизия) – За создание платформы для микрологистики и доставки в труднодоступные регионы, которая интегрирует дроны, электромобили и локальных курьеров, обеспечив доступ к услугам более чем 2 миллионам жителей.</li>
          </ul>
        </div>
      </div>
    </div>
    </>
  );
};

export default WinnersPage;
